import * as VueRouter from 'vue-router'
import config from '@/config'
import routes from '@/constants/routes'

const FinishRegistration = () => import('@/pages/registration/FinishRegistration.vue')

const router = VueRouter.createRouter({
	mode: 'history',
	history: VueRouter.createWebHistory(),
	base: '/',
	routes: [
		{
			path: '/registration',
			component: () => import('@/layout/Registration.vue'),
			redirect: { name: 'addVehicle' },
			children: [
				{
					path: 'add-vehicle',
					component: () => import('@/pages/registration/AddVehicle.vue'),
					name: 'addVehicle',
				},
				{
					path: 'add-sts',
					component: () => import('@/pages/registration/AddSts.vue'),
					name: 'addSts',
				},
				{
					path: 'add-driver-license',
					component: () => import('@/pages/registration/AddDriverLicense.vue'),
					name: 'addDriverLicense',
				},
				{
					path: 'finish-registration',
					component: FinishRegistration,
					name: 'finishRegistration',
				},
			],
		},
		{
			path: '/add-doc',
			component: () => import('@/layout/AddDoc.vue'),
			redirect: { name: 'addDocCar' },
			children: [
				{
					path: 'add-vehicle',
					component: () => import('@/components/blocks/registration/AddCarByGrz.vue'),
					name: 'addDocCar',
				},
				{
					path: 'add-sts',
					component: () => import('@/components/blocks/registration/AddSts.vue'),
					props: {
						returnToFinesList: true,
					},
					name: 'addDocSts',
				},
				{
					path: 'add-driver-license',
					component: () => import('@/components/blocks/registration/AddDriverLicense.vue'),
					name: 'addDocDriverLicense',
				},
				{
					path: 'finish-registration',
					component: FinishRegistration,
					name: 'addDocFinish',
				},
			],
		},

		{
			path: '/fine-list',
			component: () => import('@/pages/FineList.vue'),
			name: 'fineList',
		},
		{
			path: '/fine',
			component: () => import('@/pages/FineItem.vue'),
			name: 'fineItem',
		},

		{
			path: '/prepay',
			component: () => import('@/pages/Prepay.vue'),
			name: 'prepay',
			params: {
				fine_ids: '',
				order_ids: '',
				tax_ids: '',
				type: 'fine',
				click_event: '',
				from: '',
				payment_type: '',
				is_tax_ip_fssp: false,
			},
		},

		{
			path: '/taxes/documents/add',
			component: () => import('@/pages/taxes/documents/Add.vue'),
			name: 'taxesDocumentsAdd',
		},

		{
			path: '/taxes/documents/add-v2',
			component: () => import('@/pages/taxes/documents-v2/Add.vue'),
			name: 'taxesDocumentsAddV2',
		},

		{
			path: '/taxes/documents/add-v3',
			component: () => import('@/pages/taxes/documents-v3/Add.vue'),
			name: 'taxesDocumentsAddV3',
		},

		{
			path: '/taxes/list',
			component: () => import('@/pages/taxes/list/Index.vue'),
			name: 'taxesList',
		},
		{
			path: '/taxes/tax',
			component: () => import('@/pages/taxes/list/Index.vue'),
			name: 'taxeItem',
		},
		{
			path: '/additional-service',
			component: () => import('@/pages/AdditionalService.vue'),
			name: 'addService',
		},

		{ path: '/:pathMatch(.*)*', redirect: { name: 'fineList' } },
	],
})

router.afterEach(() => {
	if (window.ym) {
		window.ym(config.YM_SITEKEY, 'hit')
	}
})

router.rfNavigate = (path, params) => {
	if (window.WebToNativeBridge && window.WebToNativeBridge.update && path?.deeplink) {
		window.location.href = routes.makeDeeplink(path, params)
	} else if (path?.route) {
		if (path.route === '_BACK_') {
			router.go(-1)
		} else {
			const query = path?.query
				? path?.query.reduce((res, item) => {
						res[item] = params[item]
						return res
					}, {})
				: undefined
			router.push({
				name: path.route,
				query,
				params,
			})
		}
	}
}

export default router
